import { constants } from '@/core/constants'

export function getAbsoluteURL(url?: string) {
  if (!url) return constants.HOST_URL
  if (url.startsWith('http')) return url

  const separator = url.startsWith('/') ? '' : '/'
  return `${constants.HOST_URL}${separator}${url}`
}
